import { render, staticRenderFns } from "./DPV.vue?vue&type=template&id=79f7f02c&scoped=true"
import script from "./DPV.vue?vue&type=script&lang=js"
export * from "./DPV.vue?vue&type=script&lang=js"
import style0 from "./DPV.vue?vue&type=style&index=0&id=79f7f02c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f7f02c",
  null
  
)

export default component.exports